import * as yup from "yup";

const emptyToNull = (value: unknown, original: unknown) =>
  original === "" || original === null || original === undefined ? null : value;

export const packSchema = yup.object({
  title: yup.string().required("Title is required").max(120),
  shortId: yup
    .string()
    .required("Short ID is required")
    .matches(
      /^[a-z0-9-]+$/,
      "Short ID may contain only lowercase letters, digits and dashes"
    )
    .max(40),
  description: yup.string().max(2000),
  price: yup
    .number()
    .transform(emptyToNull)
    .typeError("Price should be a number")
    .required("Price is required")
    .moreThan(0, "Price should be greater than 0"),
  merchantPrice: yup.number().nullable().transform(emptyToNull).min(0),
  intermediateResellerPrice: yup
    .number()
    .nullable()
    .transform(emptyToNull)
    .min(0),
  confirmedResellerPrice: yup
    .number()
    .nullable()
    .transform(emptyToNull)
    .min(0),
  influencerPrice: yup.number().nullable().transform(emptyToNull).min(0),
  recommendedSellingPrice: yup
    .number()
    .nullable()
    .transform(emptyToNull)
    .min(0),
  influencerCommission: yup
    .number()
    .nullable()
    .transform(emptyToNull)
    .typeError("Commission should be a number")
    .moreThan(-0.999999, "Commission should be positive"),
  influencerCommissionPercentage: yup
    .number()
    .nullable()
    .transform(emptyToNull)
    .typeError("Commission should be a number")
    .moreThan(-0.999999, "Commission should be positive")
    .max(95, "Commission should be not more than 95%"),
  commission: yup
    .number()
    .nullable()
    .transform(emptyToNull)
    .typeError("Commission should be a number")
    .moreThan(-0.999999, "Commission should be positive"),
  commissionPercentage: yup
    .number()
    .nullable()
    .transform(emptyToNull)
    .typeError("Commission should be a number")
    .moreThan(-0.999999, "Commission should be positive")
    .max(95, "Commission should be not more than 95%"),
  discount: yup
    .number()
    .nullable()
    .transform(emptyToNull)
    .typeError("Discount should be a number")
    .moreThan(-0.999999, "Discount should be positive")
    .max(95, "Discount should be not more than 95%"),
  discountAmount: yup
    .number()
    .nullable()
    .transform(emptyToNull)
    .typeError("Discount should be a number")
    .moreThan(-0.999999, "Discount should be positive"),
  allowSellingBelowBuyingPrice: yup.boolean().default(false),
  slots: yup
    .array()
    .of(
      yup.object({
        title: yup.string().required("Slot title is required").max(120),
        position: yup.number().required(),
        options: yup
          .array()
          .of(
            yup.object({
              productVariantId: yup.string().required(),
              position: yup.number().required()
            })
          )
          .min(1, "Each slot must have at least one option")
          .required()
      })
    )
    .min(1, "At least one slot is required")
    .test(
      "uniquePositions",
      "Slot positions must be unique",
      (slots) =>
        !slots ||
        new Set(slots.map((slot) => slot.position)).size === slots.length
    )
    .required()
});
